

import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
// import { WasteCollectorMenu } from './WasteCollectorMenu'
import { FacilityMenu } from './FacilityMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { SupplyLedgerReportWrapper } from '../data-administration/data-admininstration-list/supply-ledger/supplyLedgerReportList'



import { UserInformationWrapper } from '../data-administration/data-admininstration-list/userInformation/userInformationList'
import { CompilanceWrapper } from '../data-administration/data-admininstration-list/compilance/compilanceList'
import { ProcessingCapacityWrapper } from '../data-administration/data-admininstration-list/processingCapacity/processingCapacity'
import { SupplyChainsListWrapper } from '../settings/settting-modules/supplyChains/supplyChainsList'

import { PurchaseOrdersWrapper } from '../data-administration/data-admininstration-list/purchase-orders/purchaseOrdersList'

import { PayblesFacility } from '../data-administration/data-admininstration-list/PayblesFacility/PayblesFacility'
import { ReceivableFacility } from '../data-administration/data-admininstration-list/PayblesFacility/RecivablesFacility'
import { UserIncentiveWrapper } from '../data-administration/data-admininstration-list/incentive/userIncentiveList'



const usersBreadcrumbs: Array<PageLink> = [
    {
        title: 'Transactions',
        path: '/apps/waste-source',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const FacilityPage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route index element={<FacilityMenu />} />
                <Route
                    path='user-information'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Material Hub</PageTitle>
                            <UserInformationWrapper />
                        </SuspensedView>
                    }
                />
                <Route
                    path='user-incentive'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Material Hub</PageTitle>
                            <UserIncentiveWrapper />
                        </SuspensedView>
                    }
                />
                <Route
                    path='compliance'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Compliance</PageTitle>
                            <CompilanceWrapper />
                        </SuspensedView>
                    }
                />
                <Route
                    path='processing-capacity'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Processing Capacity</PageTitle>
                            <ProcessingCapacityWrapper />
                        </>
                    }
                />

                <Route
                    path='supply-chains'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Supply chain</PageTitle>
                            <SupplyChainsListWrapper />
                        </SuspensedView>
                    }
                />


                <Route
                    path='purchase-orders'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Purchase Order</PageTitle>
                            <PurchaseOrdersWrapper />
                        </SuspensedView>
                    }
                />



                <Route
                    path='payables-facility'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Payables</PageTitle>
                            <PayblesFacility />
                        </SuspensedView>
                    }
                />

                <Route
                    path='receivables-facility'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Receivables</PageTitle>
                            <ReceivableFacility />
                        </SuspensedView>
                    }
                />


            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default FacilityPage
